<h2 class="default-dialog-header" mat-dialog-title>
	<span fxFlex>Price Review</span>
	<span fxFlex fxLayoutAlign="end end">
		<mat-icon (click)="closeDialog()" class="primary-light-color cursor-pointer">close</mat-icon>
	</span>
</h2>
<mat-divider></mat-divider>

<mat-dialog-content style="padding: 1.5rem 1.5rem 1rem 1.5rem; margin: 1px; font-size: 12px">
	<form [formGroup]="priceReviewForm">
		<div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="2rem">
			<div fxFlex>
				<mat-form-field style="width: 100%">
					<input formControlName="allInPrice" matInput placeholder="All In" type="number" />
				</mat-form-field>
			</div>
		</div>

		<div #div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="1rem">
			<div fxFlex>
				<mat-form-field fxFlex="100">
					<input
						(click)="picker1.open()"
						[matDatepicker]="picker1"
						formControlName="lastBooked"
						matInput
						placeholder="Last Booked"
					/>
					<mat-datepicker-toggle [for]="picker1" matSuffix tabIndex="-1"></mat-datepicker-toggle>
					<mat-datepicker #picker1></mat-datepicker>
				</mat-form-field>
			</div>
		</div>

		<div fxLayoutAlign="end end" fxLayoutGap="1rem">
			<button
				(click)="submitReview()"
				*ngIf="!isRequestInProgress"
				[disabled]="!this.priceReviewForm.valid"
				class="focused-button"
				color="primary"
				mat-raised-button
			>
				Submit Review
			</button>
			<mat-spinner *ngIf="isRequestInProgress" [diameter]="30"></mat-spinner>
		</div>
	</form>
</mat-dialog-content>
